import {adminRequest, requireData} from './adminRequest';
import {adminRecommendationRebuildEndpoint} from '../constants/endpoints';

export type RebuildState = 'Idle' | 'Queued' | 'Running';

export interface RecommendationRebuildStatus {
  state: RebuildState | number;
  reason?: string | null;
  runsAgain: boolean;
  lastStartedAtUtc?: string | null;
  lastFinishedAtUtc?: string | null;
  lastSucceeded?: boolean | null;
  lastError?: string | null;
  lastCitiesProcessed?: number | null;
}

// The API may serialize the state enum as a number.
const stateNames: RebuildState[] = ['Idle', 'Queued', 'Running'];

export const rebuildState = (
  status?: RecommendationRebuildStatus,
): RebuildState =>
  typeof status?.state === 'number'
    ? (stateNames[status.state] ?? 'Idle')
    : (status?.state ?? 'Idle');

export const fetchRebuildStatus =
  async (): Promise<RecommendationRebuildStatus> =>
    requireData(
      await adminRequest<RecommendationRebuildStatus>(
        {endpoint: adminRecommendationRebuildEndpoint, method: 'GET'},
        'Failed to fetch the recommendation rebuild status',
      ),
      'Failed to fetch the recommendation rebuild status',
    );

export const startRebuild = async (): Promise<RecommendationRebuildStatus> =>
  requireData(
    await adminRequest<RecommendationRebuildStatus>(
      {endpoint: adminRecommendationRebuildEndpoint, method: 'POST'},
      'Failed to start the recommendation rebuild',
    ),
    'Failed to start the recommendation rebuild',
  );
